import React, { Suspense, lazy } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import pages
const DiscountList = lazy(() => import('../Pages/DiscountList'));
const AddDiscount = lazy(() => import('../Pages/AddDiscount'));
const EditDiscount = lazy(() => import('../Pages/EditDiscount'));
const DiscountView = lazy(() => import('../Pages/DiscountView'));

/**
 * DiscountRoute component
 * Defines all routes related to the Discount module
 */
const DiscountRoute = ({ match }) => {
    const history = useHistory();
    const { path } = match;
    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <Route exact path={`${path}`} component={DiscountList} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path={`${path}/add`}
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <AddDiscount />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path={`${path}/edit/:slack`}
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <EditDiscount />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path={`${path}/view/:slack`}
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <DiscountView />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    )
};
// Loading component
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}

export default DiscountRoute;
